<div id="breadcrumb" style="background: url('assets/images/breadcrumb-bg.jpg');">
    
    <div class="container">

        <div class="breadcrumb-wrapper">

            <h1>About Us</h1>

            <ul>
                <li><a href="#">Home</a></li>
                <li><i class="bi bi-chevron-double-right"></i></li>
                <li><a href="#">About Us</a></li>
            </ul>

        </div>

    </div>
    
</div>

<div class="about-section style2">

    <div class="container">

        <div class="row align-items-center">

            <div class="col-lg-6">

                <div class="single-img">
                    <img src="assets/images/Untitled-1.jpg" alt="About iTech Consulting">
                </div>

            </div>

            <div class="col-lg-6">

                <div class="section-title style2 left">

                    <h2>Best Quality IT & Consulting Services We Provide</h2>

                    <div class="underline">
                        <div class="br-line"></div>
                    </div>

                    <p>
                        At iTech, we deliver high-quality IT and business consulting services designed to help organizations adapt, grow, and succeed in today’s fast-changing digital landscape. From advanced software development to IT infrastructure optimization, we empower businesses with secure, scalable, and innovative technology solutions.
                    </p>
                </div>

                <div class="about-tabs">
                    
                    <div class="tabs">
                        <div class="tab" [ngClass]="viewModel.tabLocation == 0 ? 'active' : ''" (click)="updateTabLocation(0)"> Our Mission </div>
                        <div class="tab" [ngClass]="viewModel.tabLocation == 1 ? 'active' : ''" (click)="updateTabLocation(1)"> Our Vision </div>
                        <div class="tab" [ngClass]="viewModel.tabLocation == 2 ? 'active' : ''" (click)="updateTabLocation(2)"> Awards Win </div>
                    </div>

                    <div class="content">

                        <!-- Mission -->
                        <div class="content-item" *ngIf="viewModel.tabLocation == 0">

                            <p>
                                Our mission is to empower businesses through cutting-edge IT solutions and expert consulting that drive efficiency, innovation, and measurable growth. We are committed to delivering value with every project, ensuring our clients stay ahead of the competition.
                            </p>

                            <ul>
                                <li>Deliver innovative, tailor-made technology solutions</li>
                                <li>Ensure robust cybersecurity and data protection</li>
                                <li>Build long-term client relationships through trust and excellence</li>
                            </ul>

                            <a href="#"> Read More </a>

                        </div>

                        <!-- Vision -->
                        <div class="content-item" *ngIf="viewModel.tabLocation == 1">

                            <p>
                                Our vision is to become a trusted global leader in IT and consulting, recognized for delivering impactful solutions that help businesses transform and achieve sustainable success in the digital era.
                            </p>

                            <p>
                                We aim to set new industry standards by combining technical expertise, strategic thinking, and a client-first approach in everything we do.
                            </p>

                            <ul>
                                <li>Innovate with emerging technologies</li>
                                <li>Expand globally while maintaining personalized client care</li>
                            </ul>

                            <a href="#"> Read More </a>

                        </div>

                        <!-- Awards -->
                        <div class="content-item" *ngIf="viewModel.tabLocation == 2">

                            <p>
                                Over the years, we have been honored with multiple industry awards for our excellence in IT service delivery, innovation, and client satisfaction. These accolades reflect our commitment to delivering exceptional value and quality.
                            </p>

                            <ul>
                                <li>Best IT Consulting Firm – 2023</li>
                                <li>Excellence in Cloud Solutions – 2022</li>
                                <li>Top 10 Digital Transformation Companies – 2021</li>
                                <li>Outstanding Customer Service Award – 2020</li>
                            </ul>

                            <a href="#">Read More</a>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>




<div id="team-section">

    <div class="container">

        <div class="section-title center">

            <h4>Team Member</h4>
            <h2>Honorable Member</h2>

            <div class="underline">
                <div class="br-line"></div>
            </div>

            <p>
                Our success is driven by a team of skilled IT professionals, consultants, and innovators who bring deep expertise, creativity, and dedication to every project. With a passion for technology and a commitment to excellence, we work together to deliver solutions that help our clients achieve sustainable growth in a fast-changing digital world.
            </p>

        </div>

        <div class="row">

            <div class="col-md-6 col-lg-4">
                <div class="single-team">
                    <div class="team-inner">
                        <div class="team-image">
                            <img src="assets/images/team01.jpg" alt="Team Member - Web Developer">
                            <div class="social-icons">
                                <ul>
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="team-content">
                        <div class="team-description">
                            <h4>Stefina Williams</h4>
                            <p>Senior Web Developer</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-4">
                <div class="single-team">
                    <div class="team-inner">
                        <div class="team-image">
                            <img src="assets/images/team02.jpg" alt="Team Member - IT Consultant">
                            <div class="social-icons">
                                <ul>
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="team-content">
                        <div class="team-description">
                            <h4>Michael Anderson</h4>
                            <p>Lead IT Consultant</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-4">
                <div class="single-team">
                    <div class="team-inner">
                        <div class="team-image">
                            <img src="assets/images/team03.jpg" alt="Team Member - Project Manager">
                            <div class="social-icons">
                                <ul>
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="team-content">
                        <div class="team-description">
                            <h4>Sarah Johnson</h4>
                            <p>Project Manager</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</div>


<footer id="footer">
    <div class="container">
        <div class="row">

            <!-- About Section -->
            <div class="col-md-6 col-lg-3">
                <div class="about">
                    <img class="logo" src="assets/icons/Transparent-2.png" alt="iTech Logo">
                    <p>
                        iTech is a leading IT solutions and consultancy provider, helping businesses
                        innovate, streamline operations, and achieve sustainable growth. From
                        software development to cloud transformation, we deliver secure, scalable,
                        and tailored solutions to meet your unique business needs.
                    </p>
                    <div class="social-icon">
                        <a href="#"><i class="bi bi-facebook"></i></a>
                        <a href="#"><i class="bi bi-twitter"></i></a>
                        <a href="#"><i class="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>

            <!-- Quick Links -->
            <div class="col-md-6 col-lg-3">
                <div class="quick-link">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="#">Product Design</a></li>
                        <li><a href="#">Application Development</a></li>
                        <li><a href="#">Cyber Security</a></li>
                        <li><a href="#">Data Quality Management</a></li>
                        <li><a href="#">IT Consultancy</a></li>
                        <li><a href="#">Mobile Development</a></li>
                        <li><a href="#">Cloud Migration</a></li>
                    </ul>
                </div>
            </div>

            <!-- Address -->
            <div class="col-md-6 col-lg-3">
                <div class="address">
                    <h4>Our Address</h4>
                    <img src="assets/images/img-footer-map.png" alt="Map">
                    <p>
                        <i class="bi bi-geo-alt-fill"></i>
                        <span>91 Western Road, Brighton, England</span>
                    </p>
                </div>
            </div>

            <!-- Contact Info -->
            <div class="col-md-6 col-lg-3">
                <div class="contact">
                    <h4>Contact Us</h4>

                    <div class="phone">
                        <p>
                            <i class="bi bi-telephone-fill"></i>
                            <a href="tel:+441632960896">+44 1632 960896</a>
                        </p>
                    </div>

                    <div class="email">
                        <p>
                            <i class="bi bi-envelope-fill"></i>
                            <a href="mailto:info@itech.com">info@itech.com</a>
                        </p>
                    </div>

                    <div class="subscribe">
                        <p>Subscribe to our Newsletter</p>
                        <form action="#">
                            <input type="email" placeholder="Your email" required>
                            <button type="submit"><i class="bi bi-arrow-right"></i></button>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        <!-- Copyright -->
        <div class="copyright">
            <div class="left">
                <p>Copyright © 2025 iTech. All rights reserved.</p>
            </div>
            <div class="copyright-menu">
                <ul>
                    <li><a href="#">Terms & Condition</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                    <li><a href="#">Contact Us</a></li>
                </ul>
            </div>
        </div>

    </div>
</footer>
